
import { FamilyMember } from '@/types';
import { getAncestorLineage } from './ancestors';

export function searchMembers(
  query: string,
  members: FamilyMember[],
  excludeId?: string
): Array<{ member: FamilyMember; path: string }> {
  if (!query || query.length < 2) return [];

  const searchTerms = query.toLowerCase().split(/\s+/);
  
  return members
    .filter(member => 
      member.id !== excludeId && 
      searchTerms.every(term => member.name.toLowerCase().includes(term))
    )
    .map(member => ({
      member,
      path: getAncestorLineage(member.id, members)
    }))
    .slice(0, 5);
}
